import { get, post } from '@/core/request'

// 编号查询区域
export const getZoneDetail = params => get(`/h5/zone/get`, params)

// 编号查询区域商品
export const getZoneProduct = params => get(`/h5/zone/getProduct2/${params.zondId}`, params)

// 查询商品详情
export const getProductDetail = data => post(`/h5/product/detail`, data)

// 全量查询商品列表
export const getProductList = data => post(`/h5/product/index`, data)

// 游客查询
export const getTourist = data => post(`/h5/consumer/index`, data)

// 新增游客
export const addTourist = data => post(`/h5/consumer/add`, data)

// 删除游客
export const delTourist = data => post(`/h5/consumer/delete`, data)

// 编辑修改游客
export const editTourist = data => post(`/h5/consumer/edit`, data)

// 游客信息
export const getTouristDetail = id => post(`/h5/consumer/get/${id}`)

// 下单
export const createOrder = data => post(`/h5/order/create`, data)

// 支付
export const payOrder = data => post(`/h5/order/pay`, data)

// 分页查询订单
export const getOrderList = data => post(`/h5/order/index`, data)

// 订单详情
// export const getOrderDetail = data => post(`/h5/order/detail`, data)

// 退票
export const refundOrder = data => post(`/h5/order/refund`, data)

// 登录
export const login = corpId => post(`/open/login/login?corpId=${corpId}`)

// 查询订单状态
export const getOrderStatus = id => get(`/h5/order/status?id=${id}`)

// 获取优惠信息
export const getDiscount = data => post(`/h5/discount/list`, data)
